import BaseService from '../../base/base_service';
import Event from '../../utils/event';

import INetPositionService, {INetPositionGameInfo} from './netent_service_interface';
import {SYSTEM_EVENTS} from "../../events/events";
import {INetPositionGameTypeData} from "../player_messages_service/firebase/handlers/netposition_handler";
import {Check} from "@sparkware/app-utils";


interface NetPositionServiceParams {
    readonly initializeGameTypeUrl: string
}

export default class NetPositionService extends BaseService implements INetPositionService {
    static CLASS = 'NetPositionService';

    private _params: NetPositionServiceParams;
    private gamesNetPositions: INetPositionGameInfo = {};

    init(params: NetPositionServiceParams) {
        super.init(params);
        this._params = params;

        this._subscribe();
    }

    async initializeNetPositionOnGameType(gameType: number) {
        try{
            return await this.serviceFactory.http2Service().post(this._params.initializeGameTypeUrl, {gameType})
        }catch (e) {
            this.logger.error("NetPosition initialize request for gameType "+gameType+" failed.");
            return null;
        }
    }

    private _onReceivedData(gamesTypesData: INetPositionGameTypeData[]) {
        const netPositions = (gamesTypesData || []).reduce((acc, gameData: INetPositionGameTypeData) => {
            if (Check.isNumber(gameData?.gameTypeId) && Check.isNumber(gameData?.amount))
                acc[gameData.gameTypeId] = gameData.amount;

            return acc;
        }, {});

        this.logger.debug("NetPosition Firebase amount received", this.gamesNetPositions);
        Event.fire(SYSTEM_EVENTS.NET_POSITION_VALUE_UPDATE, netPositions);
    }

    private _subscribe() {
        Event.on(SYSTEM_EVENTS.SESSION_EVENT_NET_POSITION_UPDATE, this._onReceivedData.bind(this));
    }
}
